import styled from 'styled-components';

export const Container = styled.div(
  props => `
  display: flex;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
  border-radius: ${props.theme.misc.borderRadius.large};
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.large} ;
  margin: 0 0 ${props.theme.spacing.custom(8)} 0;
  cursor: pointer;
`,
);

export const IconWrap = styled.div(
  props => `
  padding:${props.theme.spacing.custom(7)};
  margin: 0 ${props.theme.spacing.base} 0 0;
  width:3.2rem;
  height:3.2rem;
  border-radius:50%;
  background-color:${props.theme.colors.goBrandBlue.base};
`,
);

export const offerIconProps = {
  width: '1.8rem',
  height: '1.8rem',
  fill: 'white',
};

export const SignUpStaticText = styled.p(
  props => `
  display: inline-flex;
  color:${props.theme.colors.downriver.dark};
`,
);

export const DealsPersuasionText = styled.p(
  props => `
  display: inline-flex;
  color:${props.theme.colors.goBrandBlue.base};
  font-weight:bold;
  font-size:${props.theme.font.custom(16)};
  @media (min-width: 768px) and (max-width: 1024px) {
    font-size:${props.theme.font.custom(14)};
  }
`,
);
